import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: "23b1b095-0896-4b01-b91b-df292e53ca02",
        authority: "https://login.microsoftonline.com/473672ba-cd07-4371-a2ae-788b4c61840e",
        redirectUri: "https://zhiva.zurich.com/",
        postLogoutRedirectUri: "https://zhiva.zurich.com/"
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["api://23b1b095-0896-4b01-b91b-df292e53ca02/.default"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const directLineEndpointConfig = {
    directLineTokenEndpoint: "https://zhiva.zurich.com/api/token"
};
